import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

const Cta = () => {
  return (
    <div className="bg-gray-50 text-black py-10 sm:py-20 lg:py-20">
      <div className="max-w-4xl mx-auto px-6 text-center">
        
        {/* Label */}
        <p className="text-[10px] sm:text-xs tracking-[0.3em] uppercase text-gray-500 mb-6 sm:mb-8">
          Join Our Mission
        </p>

        {/* Heading */}
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-thin mb-10 sm:mb-12">
          Ready to Transform
          <br />
          <em className="text-gray-600">Your Future?</em>
        </h2>

        {/* Buttons */}
        <div className="flex flex-col sm:flex-row gap-6 justify-center items-center">
          
          {/* Programs Button */}
          <Link to="/programs">
            <button className="group border border-black px-10 sm:px-12 py-4 text-sm tracking-[0.2em] uppercase hover:bg-black hover:text-white transition-all duration-300 rounded-md">
              <span className="flex items-center group-hover:tracking-[0.3em] transition-all duration-300">
                Explore Programs
                <ArrowRight
                  className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform"
                />
              </span>
            </button>
          </Link>

          {/* Divider (Desktop Only) */}
          <div className="w-px h-10 sm:h-12 bg-gray-300 hidden sm:block" />

          {/* Partner Button */}
          <Link to="/enterprise">
            <button className="text-sm tracking-[0.2em] uppercase text-gray-600 hover:text-black transition-colors">
              Partner With Us →
            </button>
          </Link>

        </div>
      </div>
    </div>
  );
};

export default Cta;
